lastWatchOptions